'use strict';

/**
 * Returns an array of common keys between two objects.
 *
 * @template A - The type of the first object.
 * @template B - The type of the second object.
 * @param {A} a - The first object.
 * @param {B} b - The second object.
 * @returns {(keyof A & keyof B)[]} - An array of common keys between the two objects.
 */ function getCommonKeys(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return aKeys.filter((v)=>bKeys.includes(v));
}

module.exports = getCommonKeys;
